import type { ExportJobRecord } from '../../domains/export/models/ExportRequest';
import { buildDownloadDisposition } from '../../domains/export/utils/contentDisposition';

interface DownloadableArtifact {
  blob: Blob;
  filename?: string;
  contentType?: string | null;
}

export function downloadArtifactBlob(
  job: Pick<ExportJobRecord, 'id' | 'format'> | null | undefined,
  artifact: DownloadableArtifact,
) {
  const url = URL.createObjectURL(artifact.blob);
  const anchor = document.createElement('a');
  anchor.href = url;

  const fallbackName = extractFilenameFromDisposition(job, artifact.contentType);
  anchor.download = artifact.filename || fallbackName;

  document.body.appendChild(anchor);
  try {
    anchor.click();
  } finally {
    anchor.remove();
    // The browser consumes download URLs asynchronously. Keep the Blob alive
    // after the click so WebKit/embedded browsers can start reading it.
    setTimeout(() => URL.revokeObjectURL(url), 60_000);
  }
}

function extractFilenameFromDisposition(
  job: Pick<ExportJobRecord, 'id' | 'format'> | null | undefined,
  contentType?: string | null,
) {
  const id = job?.id ?? 'artifact';
  const disposition = buildDownloadDisposition(id, job?.format, contentType);
  const match = disposition.match(/filename="([^"]+)"/);
  return match?.[1] ?? `diagram-export-${id}.svg`;
}
